import { ProjectStatus } from './projectStatus';
import { COLORS } from '../globalStyle/colors';
import { Str } from '../localization/translationKeys';
import { Project, Requirement } from './models';


export const statusToColor = (status: ProjectStatus): string => {
  switch (status) {
    case ProjectStatus.NotStarted:
      return COLORS.RED;

    case ProjectStatus.InProgress:
      return COLORS.GREEN;

    case ProjectStatus.Expired:
      return COLORS.DARK_GREY;
  }
};


export const getProjectStatus = (project: Project): ProjectStatus => {
  if (project.expired) {
    return ProjectStatus.Expired;
  }

  if (project.statusMessageKey === Str.NotStarted) {
    return ProjectStatus.NotStarted;
  }

  return ProjectStatus.InProgress;
};


/**
 * Use this to check whether a rater of the level specified by the provided maybe requirement, can be added to the
 * project.
 *
 * @param maximumsRequired - whether the project allow only adding raters up to the maximum counts specified per
 * requirement
 * @param requirement - the requirement to check against
 * @returns true if the requirement does not exist or the maximum count for the requirement has not been met, otherwise
 * false
 */
export const canAddRaterForLevel = (
  maximumsRequired: boolean,
  requirement?: Requirement,
) => !maximumsRequired
     || !requirement
     || !requirement.maximumRequired
     || (!!requirement.maximumRequired && requirement.raterCount < requirement.maximumRequired);
